<template>
  <div style="margin: 0px 0 0 40px">
    <h3 style="margin-top: 0">流程</h3>
    <a-timeline>
      <a-timeline-item v-for="item in lineData" :key="item.key">
        <h4 style="margin: 0">{{ item.name }}</h4>
        <div style="color: gray" v-if="item.role">角色：{{ item.role.name }}</div>
        <div style="color: gray" v-if="item.role">是否会签：{{ item.countersign == 1 ? '是' : '否' }}</div>
        <div style="color: gray" v-if="item.role">是否企业审核：{{ item.company_check == 1 ? '是' : '否' }}</div>
        <div style="color: gray">{{ item.remark }}</div>
      </a-timeline-item>
    </a-timeline>
  </div>
</template>
<script setup>
  import { ref, defineProps, computed } from 'vue'

  const props = defineProps({
    processNode: Array,
    selected: Array,
  })

  const lineData = computed(() => {
    if (!props?.processNode?.length || !props?.selected?.length)
      return [{ name: '暂未选中节点，请按顺序添加节点', key: '' }]
    // const data = props.processNode
    //   .filter((item) => {
    //     return props.selected.find((selected) => selected === item.key)
    //   })
    return props.selected.map((selected) =>
      props.processNode.find((node) => node.key === selected)
    )
  })
</script>
